import { 
     NgModule,
     Component,
     Input,
     Inject,
     ChangeDetectionStrategy,
     PLATFORM_ID,
     OnChanges,
     OnInit,
     SimpleChanges,
     ChangeDetectorRef,
     ElementRef,
     Renderer2
} from '@angular/core';


import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Component({
    selector: 'ad',
    templateUrl: 'ad.template.html',
    styleUrls: ['./ad.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdComponent {
    @Input() template;
    @Input() type: string;
    private renderer;
    private element;
    constructor(
        elementRef: ElementRef,
        renderer: Renderer2
    ){
        this.element = elementRef.nativeElement;
        this.renderer = renderer;
    }

    ngOnChanges(changes){
        
    }

    ngOnInit(){

    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/ad/ad.component.ts